export const GET_SETTINGS = "GET_SETTINGS";

const initialState = {
  settings: {},
  country_codes: [],
};

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    default:
      return state;
  }
}
